<script setup lang="ts">
import LogInButton from '@/components/buttons/specific/LogInButton.vue'
/**
 * Used as main layout mounted by App objects when user is not authenticated; See App.vue
 */
import { Card, CardHeader } from '@/components/shad/ui/card'
import { Separator } from '@/components/shad/ui/separator'
import useDarkMode from '@/composables/useDarkMode.store'
import { updateTitle } from '@/router/helpers'
import { onMounted } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const darkMode = useDarkMode()

onMounted(() => setTimeout(() => updateTitle(route.meta.title as string), 50))
</script>

<template>
  <div
    class="animated-background flex h-screen bg-gradient-to-bl from-surface-500 via-blue-100 to-gray-700 dark:from-surface-900 dark:via-blue-900/70 dark:to-[#000003]"
  >
    <div class="m-auto">
      <Card class="bg-surface-0/60 shadow-lg dark:bg-surface-900/40">
        <CardHeader class="m-6 items-center">
          <img
            :src="
              darkMode.isDark
                ? '/logos/galvanick-yellow.svg'
                : '/logos/galvanick-blue.svg'
            "
            class="max-w-60"
            width="150"
            alt="Galvanick logo"
          />
          <Separator class="my-3" />
          <div class="mt-3 w-full text-center">
            <slot name="default">
              <LogInButton class="w-full !bg-navy" />
            </slot>
          </div>
        </CardHeader>
      </Card>
    </div>
  </div>
</template>

<style scoped>
.animated-background {
  background-size: 150%;

  -webkit-animation: animation 20s ease infinite;
  -moz-animation: animation 20s ease infinite;
  animation: animation 20s ease infinite;
}

@keyframes animation {
  0%,
  100% {
    background-position: 0 50%;
  }

  50% {
    background-position: 100% 50%;
  }
}
</style>
